<template>
  <ul class="rating">
    <li
      v-for="star in createRange(total)"
      v-bind:key="star"
      style="list-style-type: none;"
    >
      <i class="starColour fas fa-star"></i>
    </li>
  </ul>
</template>

<script>
var range = require('lodash/range')

export default {
  props: {
    total: {
      type: String,
      default: () => null
    }
  },
  methods: {
    createRange (value) {
      return range(value)
    }
  }
}

</script>

<style scoped lang="scss">
@import "../../assets/common.scss";

.rating {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: -10%;
}

.starColour {
  color: $star-colour;
}

</style>
